import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
import { brand } from '../data/projects';
import { Projects } from './portal/Projects';
import { ProjectAdmin } from './portal/ProjectAdmin';
import { StaffAccount } from '../components/portal/StaffAccount';
export function PortalApp() {
  const {
    portalRoute,
    goPortal,
    staffUser,
    staffSignOut
  } = usePortal();
  const [accountOpen, setAccountOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  return <div className="min-h-screen w-full bg-ink text-paper" data-id="element-795" data-mp="3ledsoc5hhzyv">
      <header className="border-b border-ruleDark" data-id="element-796" data-mp="36qkcap8kqtf8">
        <div className="mx-auto flex max-w-portal items-center justify-between gap-8 px-6 py-6 sm:px-10" data-id="element-797" data-mp="36ny4qploodx0">
          <div className="flex items-center gap-3.5" data-id="element-798" data-mp="3bn11znvf9fuf">
            <img src={brand.mark} alt="" className="h-7 w-7 brightness-0 invert" data-id="element-799" data-mp="3894q0s9fx66" />
            <p className="label m-0 text-paper" data-id="element-800" data-mp="80k2oy3fx8w3">
              Portal Productions
              <span className="label-sm mt-2 block text-paper/35" data-id="element-801" data-mp="3k36yemsvd7d0">Studio Admin</span>
            </p>
          </div>

          <div className="flex items-center gap-8" data-id="element-802" data-mp="3f4vmm6j0kms5">
            <button type="button" onClick={() => {
            goPortal('projects');
            setCreating(true);
          }} className="label inline-flex items-center gap-3 border border-paper/30 px-4 py-2.5 text-paper/70 transition-colors duration-150 ease-out hover:border-paper hover:text-paper" data-id="element-803" data-mp="3f2979kpvt2zd">
              <PlusIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-804" data-mp="1oo00f6n6bfp" />
              New Project
            </button>
            {/* Whoever is signed in — never a fixed name or address. */}
            <p className="label m-0 hidden text-paper/35 sm:block" data-id="element-805" data-mp="boola6o2n1mj">
              {staffUser?.name ?? 'Portal Staff'}
              <span className="label-sm mt-2 block text-paper/25" data-id="element-806" data-mp="2iemp8rtk1n5g">{staffUser?.email}</span>
            </p>
            <button type="button" onClick={() => setAccountOpen(open => !open)} className="label text-paper/50 transition-colors duration-150 ease-out hover:text-paper" data-id="element-807" data-mp="2dgun74z74knj">
              Account
            </button>
            <button type="button" onClick={staffSignOut} className="label border border-paper/30 px-4 py-2.5 text-paper/70 transition-colors duration-150 ease-out hover:border-paper hover:bg-paper hover:text-ink" data-id="element-808" data-mp="3c2sjlb2pfgqt">
              Sign Out
            </button>
          </div>
        </div>
      </header>

      {accountOpen && <StaffAccount onClose={() => setAccountOpen(false)} data-id="element-809" data-mp="3uule59xf9a0n" />}

      <main className="mx-auto max-w-portal px-6 pb-32 pt-12 sm:px-10 sm:pt-14" data-id="element-810" data-mp="3uv3f2jv14cew">
        {portalRoute === 'projects' ? <Projects creating={creating} setCreating={setCreating} data-id="element-811" data-mp="8n3lirsuda2m" /> : <ProjectAdmin data-id="element-812" data-mp="8l0mji9po6lr" />}
      </main>
    </div>;
}